import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import axios from "axios";
import { useMediaQuery } from "react-responsive";

import { DetailEventContainer } from "./component/styled/scheduler";

import { keysToRemove } from "./component/function/common";
import { useModal } from "../../../hooks/useModal";

import MediaViewer from "../../../common/mediaViewer";
import Detail from "./component/scheduler/event/detail";
import Report from "./component/scheduler/event/report";
import Comment from "./component/scheduler/event/comment";
import Gallery from "./component/scheduler/event/gallery";
import Members from "./component/scheduler/event/members";
import TabMenu from "./component/scheduler/event/tabMenu";
import Info from "./component/detailEvent/info";
import ScheduleInfo from "./component/scheduler/event/scheduleInfo";
import UseApp from "../../../common/useApp";

const DetailEvent = () => {
  const { id } = useParams();

  const navigate = useNavigate();
  const location = useLocation();

  const isMobile = useMediaQuery({ query: "(max-width:767px)" });

  const { modal, openModal, closeModal } = useModal();

  const user = useSelector((state) => state?.user?.data[0]);
  const isDarkMode = useSelector((state) => state?.scheduler?.isDarkMode);

  const [eventInfo, setEventInfo] = useState(null);
  const [isDetail, setIsDetail] = useState(false);
  const [imageOrder, setImageOrder] = useState([]);
  const [todos, setTodos] = useState([]);
  const [active, setActive] = useState(0);
  const [comments, setComments] = useState([]);
  const [isSchedule, setIsSchedule] = useState(false);
  const [originImages, setOriginImages] = useState([]);
  const [isUpload, setIsUpload] = useState(false);
  const [isUseApp, setIsUseApp] = useState(false);

  useEffect(() => {
    if (!user) {
      navigate("/login");
      return;
    }
    if (!/^[0-9]+$/.test(id)) {
      toast.error("존재하지 않는 일정입니다.", { toastId: "no-access" });
      navigation("/mypage");
      return;
    }

    const scheduleNo = JSON.parse(sessionStorage.getItem("sharedEvent"));

    if (scheduleNo) {
      setIsUseApp(true);
    }

    getEvent();
  }, [id]);

  const navigation = (defaultPath, extra) => {
    const state = location?.state;
    if (!state) {
      navigate(defaultPath);
      return;
    }

    const { path, ...rest } = state;
    const target = path || defaultPath;
    const merged = { ...rest, ...extra };
    const data = Object.keys(merged).length > 0 ? merged : undefined;

    navigate(target, data ? { state: data } : undefined);
  };

  // 일정 조회
  const getEvent = async () => {
    try {
      const res = await axios.post("/api/scheduleList", {
        scheduleNo: id,
        mberNo: user.mberNo,
        delYn: "N",
      });

      const data = Array.isArray(res.data) ? res.data : [];
      const event = data.find((e) => e?.scheduleNo?.toString() === id);

      if (res.status !== 200 || !data.length) {
        toast.error("존재하지 않는 일정입니다.", { toastId: "no-access" });
        navigation("/mypage");
        return;
      }

      if (event) {
        setEventInfo(event);
        setIsSchedule(event.dday !== "Y");

        await getComment();
        await getImages();

        sessionStorage.removeItem("sharedEvent");
      }
    } catch (error) {
      console.error("일정 조회 오류:", error);
    }
  };

  // 댓글 조회
  const getComment = async () => {
    const url = "/api/scheduleComment/get";
    const body = { scheduleNo: id };
    try {
      const res = await axios.post(url, body);
      if (res.status === 200) {
        console.log(res);
        setComments(res.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  // 이벤트 삭제
  const submitDelete = async (event) => {
    const url = "/api/schedule";
    const body = keysToRemove(event);

    body.delYn = "Y";
    body.createMberId = user.mberNo;

    const res = await axios.put(url, body);
    if (res.status === 200) {
      toast.success(`${event.dday === "Y" ? "디데이가" : "일정이"} 삭제되었습니다.`, {
        toastId: "no-access",
      });
      navigate("/mypage/scheduler");
    }
  };

  // 이미지 조회
  const getImages = async () => {
    const url = "/api/photoList";
    const body = { refeNo: id };

    const res = await axios.post(url, body);

    setOriginImages(res.data);
  };

  const clickGallery = (flag) => {
    setIsUpload(flag);
    setActive(2);
  };

  const renderComponent = () => {
    const components = [
      <Detail
        eventInfo={eventInfo}
        isSchedule={isSchedule}
        setTodos={setTodos}
        todos={todos}
        setActive={setActive}
      />,
      <Report
        eventInfo={eventInfo}
        isSchedule={isSchedule}
        setTodos={setTodos}
        todos={todos}
        setIsDetail={setIsDetail}
        setImageOrder={setImageOrder}
        isGallery={true}
        setActive={setActive}
        originImages={originImages}
        clickGallery={clickGallery}
        isUpload={isUpload}
      />,
      <Gallery
        eventInfo={eventInfo}
        setImageOrder={setImageOrder}
        setIsDetail={setIsDetail}
        isGallery={true}
        originImages={originImages}
        getImages={getImages}
        clickGallery={clickGallery}
        isUpload={isUpload}
        getComment={getComment}
      />,
      <Comment
        eventInfo={eventInfo}
        comments={comments}
        getComment={getComment}
        setImageOrder={setImageOrder}
        setIsDetail={setIsDetail}
        getImages={getImages}
      />,
      <Members eventInfo={eventInfo} />,
    ];
    return components[active];
  };

  // 이벤트 나가기
  const exitSchedule = async (event) => {
    const url = "/api/schedule";
    const data = {
      ...event,
      workerNos: [...Object.keys(eventInfo.workerList || {})].filter(
        (mberNo) => parseInt(mberNo, 10) !== user.mberNo,
      ),
    };

    const body = keysToRemove(data);

    try {
      const res = await axios.put(url, body);
      if (res.status === 200) {
        navigate("/mypage/scheduler");
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <DetailEventContainer className={isDarkMode}>
      {modal}
      {isDetail && (
        <MediaViewer
          files={imageOrder}
          setIsOpen={setIsDetail}
          isComment={true}
          getImages={() => {
            getImages();
            getComment();
          }}
        />
      )}
      {isUseApp && isMobile && (
        <UseApp
          setIsUseApp={setIsUseApp}
          message={{
            title: "한 번의 클릭으로\n더 편리하게!",
            info: "앱 설치로 빠르고 간편하게 이용하세요",
          }}
        />
      )}
      <div className={isDarkMode}>
        {eventInfo && (
          <>
            <Info
              submitDelete={submitDelete}
              exitSchedule={exitSchedule}
              setEventInfo={setEventInfo}
              isSchedule={isSchedule}
              setActive={setActive}
              active={active}
              eventInfo={eventInfo}
              openModal={openModal}
              closeModal={closeModal}
              todos={todos}
              getEvent={getEvent}
              comments={comments}
              navigation={navigation}
            />
            <div className="content">
              <ScheduleInfo
                active={active}
                eventInfo={eventInfo}
                comments={comments}
                isSchedule={isSchedule}
                isDetail={true}
              />
              {renderComponent()}
              {active === 0 && isSchedule && (
                <TabMenu
                  setActive={setActive}
                  comments={comments}
                  images={originImages}
                  clickGallery={clickGallery}
                />
              )}
            </div>
          </>
        )}
      </div>
    </DetailEventContainer>
  );
};

export default DetailEvent;
